import {
  ReportExpense,
  useRemoveExpenseFromReportMutation,
} from "@common/utils/graphql";
import { FilePreview } from "@/components/ui/file-preview";
import { useState } from "react";
import { formatDollars, formatDate } from "@common/components/utils";
import { CaretRight, CircleNotch, X } from "@phosphor-icons/react";
import { useUpdateExpenseOutOfPolicyState } from "@common/state/outOfPolicyState";
import { ExpenseStatusText } from "../employee/ExpenseStatusText";

interface ExpenseCardProps {
  expense: ReportExpense;
  reportId: number;
  isEditMode: boolean;
  viewExpense: (expenseId: number) => void;
}

export const ExpenseCard = ({
  expense,
  reportId,
  isEditMode,
  viewExpense,
}: ExpenseCardProps) => {
  const [isDeleted, setIsDeleted] = useState(false);
  const [removeExpenseFromReport, { loading: isDeleting }] =
    useRemoveExpenseFromReportMutation();
  const updateExpenseOutOfPolicyState = useUpdateExpenseOutOfPolicyState();

  if (isDeleted && isEditMode) {
    return null;
  }

  return (
    <div className="flex flex-row gap-3">
      <div className="mt-3 flex w-full flex-col rounded-md bg-[#1B1B1B] p-3">
        <div className="flex justify-between">
          <div>
            <div className="text-base">{expense.merchantName}</div>
            <div className="text-sm text-slate">
              {formatDate(expense.transactionDate)}
            </div>
          </div>
          <div className="flex flex-col items-end justify-end">
            <div className="text-base">{formatDollars(expense.amount)}</div>
            <ExpenseStatusText expense={expense} small />
          </div>
        </div>
        <div className="flex items-center justify-between pt-2">
          <div>
            <FilePreview url={expense.receiptFileUrl} />
          </div>
          <div
            className="flex cursor-pointer justify-center align-middle text-sm"
            onClick={() => viewExpense(expense.id)}
          >
            See Details <CaretRight className="inline size-4 pt-1" />
          </div>
        </div>
      </div>
      {isEditMode && (
        <div
          className="flex items-center justify-center pt-3"
          onClick={async () => {
            if (isDeleting || isDeleted) {
              return;
            }
            await removeExpenseFromReport({
              variables: {
                reportId: reportId,
                expenseId: expense.id,
              },
            });
            updateExpenseOutOfPolicyState(expense.id);
            setIsDeleted(true);
          }}
        >
          {isDeleting ? (
            <CircleNotch className="size-4 animate-spin" />
          ) : (
            <X className="cursor-pointer" />
          )}
        </div>
      )}
    </div>
  );
};
